import React from "react";

function TextLink(props) {
	const containerClasses =
		"text-p-blue hover:underline transition-all duration-200" +
		(props.classNames || "");

	return props.withoutLink ? (
		<span className={containerClasses}>
			{props.children}
		</span>
	) : (
		<a className={containerClasses} href={props.href}>
			{props.children}
		</a>
	);
}

export default TextLink;
